export const CLIPBOARD_FORMAT_TEXT = 'text/plain'
